// Rejection wall. Shown when the account is signed in with Cognito but the server denied
// authorization for the doctor portal (wrong audience/role, off-domain, or MFA not satisfied). It
// deliberately replaces the authenticated shell — a signed-in-but-unauthorized user must never see
// the app chrome with every panel erroring. The only action is to sign out and try another account.
import { useNavigate } from "react-router-dom";
import { useAppAuth } from "../auth";
import { STAFF_DOMAINS } from "../config";
import { AuthLayout } from "./AuthLayout";

export function NotAuthorized() {
  const { signOut, displayName } = useAppAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate("/sign-in", { replace: true });
  }

  return (
    <AuthLayout>
      <div className="auth-form">
        <h2>
          Not <em>authorized.</em>
        </h2>
        <p>
          {displayName ? <strong>{displayName}</strong> : "This account"} is signed in, but isn&rsquo;t
          authorized for the Provider portal. Access is limited to ForceBase-verified staff
          ({STAFF_DOMAINS.join(", ")}).
        </p>
        <p>Sign in with an authorized account to continue.</p>
        <button type="button" className="btn btn-primary btn-lg" onClick={handleSignOut}>
          Sign out
        </button>
      </div>
    </AuthLayout>
  );
}
